import React, {useEffect, useState} from "react"
import {useLocation, useNavigate} from "react-router-dom"
// MUI
import {Button, Grid2 as Grid} from "@mui/material";
import {Save} from "@mui/icons-material";
// Components
import {BuilderShell} from "@/components/Layout";
import {packagingTokens as tk} from "@/theme/packagingTokens";
// Translation
import {useTranslation} from "react-i18next";

import {useData} from "@/context/PackagingDataProvider";
import AppEditor from "@/components/Apps/AppsEditor/AppEditor";

export default function AppBuilder(props: any) {

    const location = useLocation();
    const redirect = useNavigate()

    const {editing} = props
    const {editAny, getSingleApp} = useData()
    const {t} = useTranslation(["apps", "common"])

    // Data
    const [app, setApp] = useState<any>({
        id: "",
        name: "",
        brands_id: [],
        default: true,
        geo_ip_fallback: true,
        layout: {},
        translations: []
    })

    useEffect(() => {
        if (editing) {
            let editedApp = location.state
            getSingleApp(editedApp.id).then((res: any) => setApp(res))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props])

    const handleSaveApp = () => {
        editAny(app, "app").then((res: any) => {
            if (res) redirect("/?tab=apps")
        })
    }

    return (
        <BuilderShell
            backTo={"/?tab=apps"}
            backLabel={t("common:back")}
            title={t("app_builder")}
            subtitle={t("apps_subtitle")}
            maxWidth={1180}
            actions={
                <Button
                    startIcon={<Save sx={{fontSize: 18}} />}
                    variant={"contained"}
                    disableElevation
                    onClick={() => handleSaveApp()}
                    sx={{textTransform: "none", fontWeight: 600, borderRadius: tk.radius.sm, px: 2}}
                >
                    {t("common:save")}
                </Button>
            }
        >
            <Grid container justifyContent={"space-between"} rowSpacing={3} columnSpacing={3}>
                <AppEditor {...{app, setApp, t}} />
            </Grid>
        </BuilderShell>
    )
}
